var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import styled, { css } from "styled-components";
import Flex from "@irati/ui/src/Flex";
var Container = styled(Flex)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  font-size: 14px;\n\n  ", "\n"], ["\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  font-size: 14px;\n\n  ",
    "\n"])), function (_a) {
    var theme = _a.theme;
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    color: ", ";\n    background-color: ", ";\n    font-family: ", ";\n\n    ", "\n  "], ["\n    color: ", ";\n    background-color: ", ";\n    font-family: ", ";\n\n    ",
        "\n  "])), theme.colors.greys.white, theme.colors.perkbox.blue, theme.font.bold, theme.mediaQueries.minWidthMedia.tablet(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      width: 24px;\n      height: 24px;\n    "], ["\n      width: 24px;\n      height: 24px;\n    "]))));
});
var Badge = /** @class */ (function (_super) {
    __extends(Badge, _super);
    function Badge() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Badge.prototype.render = function () {
        var _a = this.props, className = _a.className, children = _a.children;
        return (React.createElement(Container, { className: className, alignItems: "center", justifyContent: "center" }, children));
    };
    Badge.defaultProps = {
        className: null
    };
    return Badge;
}(PureComponent));
export default Badge;
var templateObject_1, templateObject_2, templateObject_3;
